import { plickTheme } from '../theme';

// Adapted from React Native code
// Assuming IconType structure based on usage
export type IconType = {
  name: string;
  variant: 'material' | 'tabler'; // Added tabler as it's in package.json
};

type ORDER_STATUS_MAP_TYPE = {
  key: string;
  label: string;
  color: string;
  icon: IconType;
};

// Mapping palette colors to plickTheme or fallbacks
const colors = {
  red_warning: plickTheme.colors.warning || '#FF9966', // fallback
  aqua: '#00FFFF', // fallback if not in theme
  primary: plickTheme.colors.primary || '#000000',
  green: plickTheme.colors.greenDark || '#028D46',
  whatsapp: plickTheme.colors.greenLight || '#25D366',
};

export const ORDER_STATUS_MAP: Record<string, ORDER_STATUS_MAP_TYPE> = {
  pending: {
    key: 'pending',
    label: 'Pendiente',
    color: colors.red_warning,
    icon: {
      name: 'pause',
      variant: 'material',
    },
  },
  rejected: {
    key: 'rejected',
    label: 'Rechazado',
    color: colors.red_warning,
    icon: {
      name: 'no-meals',
      variant: 'material',
    },
  },
  accepted: {
    key: 'accepted',
    label: 'Aceptado',
    color: '#F9B234',
    icon: {
      name: 'local-fire-department',
      variant: 'material',
    },
  },
  arrived_at_pickup: {
    key: 'arrived_at_pickup',
    label: 'Repartidor llegó a recoger',
    color: '#5D4DBA',
    icon: {
      name: 'outbox',
      variant: 'material',
    },
  },
  on_the_way: {
    key: 'on_the_way',
    label: 'En camino',
    color: colors.aqua,
    icon: {
      name: 'motorcycle',
      variant: 'material',
    },
  },
  arrived_at_delivery: {
    key: 'arrived_at_delivery',
    label: 'Repartidor entregando',
    color: '#08C380',
    icon: {
      name: 'house',
      variant: 'material',
    },
  },
  delivered: {
    key: 'delivered',
    label: 'Entregado',
    color: colors.primary,
    icon: {
      name: 'restaurant',
      variant: 'material',
    },
  },
  ready_to_pick_up: {
    key: 'ready_to_pick_up',
    label: 'Listo para recoger',
    color: colors.primary,
    icon: {
      name: 'room-service',
      variant: 'material',
    },
  },
} as const;

export const NOTIFICATION_EVENTS_MAP = {
  newOrder: {
    key: 'newOrder',
  },
  changeOrderStatus: {
    key: 'changeOrderStatus',
  },
} as const;
